import { inject, Injectable } from '@angular/core';
import { CrmLayoutMenuProvider, CrmLayoutSiderControl } from '@touch4it/ng-swp/layout-v2';
import { map } from 'rxjs';

import { AuthService } from '~/api/auth/auth.service';
import { isVisibleForRoles } from '~/shared/types/user.role';

@Injectable({ providedIn: 'root' })
export class MenuProvider extends CrmLayoutMenuProvider {
  private user = inject(AuthService);

  override items$(_options: { siderControl?: CrmLayoutSiderControl }) {
    return super
      .items$(_options)
      .pipe(map((items) => items.filter(({ role }) => isVisibleForRoles(role, this.user.userRoles()))));
  }
}
